import moment from "moment";
String.prototype.toHex = function () {
  var hash = 0;
  if (this.length === 0) return hash;
  for (var i = 0; i < this.length; i++) {
    hash = this.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }
  var color = '#';
  for (var i = 0; i < 3; i++) {
    var value = (hash >> (i * 8)) & 255;
    color += ('00' + value.toString(16)).substr(-2);
  }
  return color;
}
export function formatDateForTable(dataDate) {
  // moment(dataDate).format('h:mm:ss d/MM');
  return moment(dataDate).format('DD/MM/YYYY')
}

export function hasSameValues(current, changed) {
  let change = false;
  for (let i = 0; i < Object.entries(changed).length; i++) {
    let [name, value] = Object.entries(changed)[i];
    if (current[name] !== value) {
      change = true;
      break;
    }
    change = false;
  }
  return change;
}

export function validateEmptyFields(data, { validate, skip_fields = [] }) {
  let disable = true;
  const empty = Object.entries(data).filter(([name, value]) => {
    return skip_fields.includes(name) ? false : (value === "" || value === null || value === undefined);
  });
  disable = empty.length !== 0;
  disable = typeof validate === 'function' ? validate(data) : disable
  return disable;
}

export function removeAccents(string) {
  const accents = { 'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u', 'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U' };
  return string.split('').map(lyrics => accents[lyrics] || lyrics).join('').toString();
}

export const currencyFormatter = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});
export const currencyIntFormatter = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const downloadFile = (data, fileName) => {
  const blob = new Blob([data]);
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

export const downloadStaticFile = (fileUrl, fileName) => {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

export function hideEmail(email) {
  if (typeof email !== 'string') {
    return 'Invalid email';
  }

  const atIndex = email.indexOf('@');

  if (atIndex < 0) {
    return email; // No '@' symbol found, so return the original email
  }

  const username = email.slice(0, atIndex);
  const hiddenPart = '*'.repeat(username.length - 3) + email.slice(atIndex - 3);

  return hiddenPart;
}

export function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function sortArrayBy(array, processor, ascending = true) {
  return [...(array || [])].sort((a, b) => {
    if (processor(a) < processor(b)) {
      return ascending ? -1 : 1;
    }
    if (processor(a) > processor(b)) {
      return ascending ? 1 : -1;
    }
    return 0;
  });
}

export function compareObjects(obj1, obj2) {
  // Compara si dos objetos tienen los mismos valores en sus propiedades
  const keys1 = Object.keys(obj1).filter(key => !['page', 'limit'].includes(key));
  const keys2 = Object.keys(obj2 || {}).filter(key => !['page', 'limit'].includes(key));

  if (keys1.length !== keys2.length) return false;

  for (let key of keys1) {
    const val1 = obj1[key];
    const val2 = obj2[key];

    // Si ambos son arrays, compara sus elementos
    if (Array.isArray(val1) && Array.isArray(val2)) {
      if (val1.length !== val2.length) return false;
      for (let i = 0; i < val1.length; i++) {
        if (val1[i] instanceof Date && val2[i] instanceof Date) {
          if (val1[i].getTime() !== val2[i].getTime()) return false;
        } else if (val1[i] !== val2[i]) {
          return false;
        }
      }
    } else if (val1 instanceof Date && val2 instanceof Date) {
      if (val1.getTime() !== val2.getTime()) return false;
    } else if (val1 !== val2) {
      return false;
    }
  }
  return true;
}

export function toTitleCase(str) {
  return str ? str.replace(
    /\w\S*/g,
    function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  ) : null;
}

export function filterDuplicates(arr, field) {
  if (!Array.isArray(arr)) return;
  const uniqueValues = new Set();
  return arr.filter((obj) => {
    if (!uniqueValues.has(obj[field])) {
      uniqueValues.add(obj[field]);
      return true;
    }
    return false;
  });
}